<div id="pr-sidepanel" [ngClass]="{ opened: opened, left: side == 'left' }">
  <ng-content></ng-content>
</div>
<div id="pr-sidepanel-backdrop" (click)="confirmCloseSidePanel()"></div>
